if (!customElements.get('product-comparison-grid')) {
  class ProductComparisonGrid extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('.product-comparison-grid');
      this.rows = this.grid ? this.grid.querySelectorAll('tr') : [];
      this.mobileSpecs = this.querySelectorAll('.product-comparison-mobile__spec');
      this.gridContainer = this.querySelector('.product-comparison-container');
      this.showAllButton = this.querySelector('.js-show-all');

      if (this.showAllButton) {
        this.showAllButton.addEventListener('click', this.handleShowAllClick.bind(this));
      }

      if (this.dataset.comparisonLengthSync === 'true') {
        this.initLengthSync();
      }
    }

    initLengthSync() {
      const dataEl = this.querySelector('.js-comparison-data');
      if (!dataEl) return;

      try {
        this.comparisonData = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      this.emptyText = this.comparisonData.emptyText || '-';
      this.handleVariantChange = this.handleVariantChange.bind(this);

      document.addEventListener('on:variant:change', this.handleVariantChange);
      document.addEventListener('on:spec-variant:change', this.handleSpecVariantChange.bind(this));

      this.setInitialLength();
    }

    normalizeLengthKey(value) {
      if (!value) return '';

      return String(value)
        .toLowerCase()
        .replace(/,/g, '.')
        .replace(/\s+/g, '')
        .replace(/m/g, '')
        .trim();
    }

    getLengthKeyFromVariant(variant) {
      if (!variant) return '';

      const products = this.comparisonData?.products || [];

      for (let i = 0; i < products.length; i += 1) {
        const match = products[i].variants.find((entry) => String(entry.id) === String(variant.id));
        if (match?.lengthKey) return match.lengthKey;
      }

      const source = variant.option1 || variant.options?.[0] || variant.title || '';
      return this.normalizeLengthKey(source);
    }

    handleVariantChange(event) {
      const lengthKey = this.getLengthKeyFromVariant(event.detail?.variant);
      if (lengthKey) this.updateByLengthKey(lengthKey);
    }

    handleSpecVariantChange(event) {
      const variantId = event.detail?.variantId;
      if (!variantId) return;

      const products = this.comparisonData?.products || [];

      for (let i = 0; i < products.length; i += 1) {
        const match = products[i].variants.find((entry) => String(entry.id) === String(variantId));
        if (match?.lengthKey) {
          this.updateByLengthKey(match.lengthKey);
          return;
        }
      }
    }

    setInitialLength() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');

      if (urlVariantId) {
        const products = this.comparisonData?.products || [];

        for (let i = 0; i < products.length; i += 1) {
          const match = products[i].variants.find((entry) => String(entry.id) === String(urlVariantId));
          if (match?.lengthKey) {
            this.updateByLengthKey(match.lengthKey);
            return;
          }
        }
      }

      const variantInput = document.querySelector('.js-product-form-main input[name="id"]');
      if (variantInput?.value) {
        const products = this.comparisonData?.products || [];

        for (let i = 0; i < products.length; i += 1) {
          const match = products[i].variants.find((entry) => String(entry.id) === String(variantInput.value));
          if (match?.lengthKey) {
            this.updateByLengthKey(match.lengthKey);
            return;
          }
        }
      }
    }

    updateByLengthKey(lengthKey) {
      const products = this.comparisonData?.products || [];

      products.forEach((productData, productIndex) => {
        const match = productData.variants.find((entry) => entry.lengthKey === lengthKey);

        this.querySelectorAll(`[data-comparison-product-index="${productIndex}"]`).forEach((cell) => {
          const field = cell.dataset.comparisonField;

          if (!match) {
            if (field === 'price') {
              cell.innerHTML = this.emptyText;
            } else {
              cell.textContent = this.emptyText;
            }
            return;
          }

          if (field === 'length') {
            cell.textContent = match.length || this.emptyText;
          } else if (field === 'weight') {
            cell.textContent = match.weight || this.emptyText;
          } else if (field === 'section_count') {
            cell.textContent = match.sectionCount || this.emptyText;
          } else if (field === 'collapsed_length') {
            cell.textContent = match.collapsedLength || this.emptyText;
          } else if (field === 'perceived_weight') {
            cell.textContent = match.perceivedWeight || this.emptyText;
          } else if (field === 'price') {
            cell.innerHTML = `<div class="price"><div class="price__default"><strong class="price__current">${match.priceFormatted}</strong></div></div>`;
          }
        });
      });
    }

    /**
     * Handles 'click' events on the show all rows button
     * @param {object} evt - Event object.
     */
    handleShowAllClick(evt) {
      if (!this.grid || !this.gridContainer) return;

      const buttonText = evt.target.textContent;
      evt.target.textContent = evt.target.dataset.toggleText;
      evt.target.dataset.toggleText = buttonText;

      const gridHeight = this.grid.clientHeight;
      this.gridContainer.style.maxHeight = `${gridHeight}px`;
      this.gridContainer.style.overflow = 'hidden';
      this.gridContainer.classList.add('is-transitioning');

      let heightReduction = 0;
      const toggleHidden = (element) => {
        if (element.classList.contains('js-hidden')) {
          element.classList.remove('js-hidden');
          element.dataset.wasHidden = 'true';
        } else if (element.dataset.wasHidden) {
          heightReduction += element.clientHeight;
        }
      };

      this.rows.forEach(toggleHidden);
      this.mobileSpecs.forEach(toggleHidden);

      this.gridContainer.style.maxHeight = `${heightReduction > 0 ? gridHeight - heightReduction : this.grid.clientHeight}px`;

      setTimeout(() => {
        if (heightReduction > 0) {
          const hideToggled = (element) => {
            if (element.dataset.wasHidden === 'true') {
              element.classList.add('js-hidden');
              element.removeAttribute('was-hidden');
            }
          };

          this.rows.forEach(hideToggled);
          this.mobileSpecs.forEach(hideToggled);
        }

        this.gridContainer.style.maxHeight = '';
        this.gridContainer.style.overflow = '';
        this.gridContainer.classList.remove('is-transitioning');
      }, (parseFloat(window.getComputedStyle(this.gridContainer).transitionDuration) * 1000));
    }
  }

  customElements.define('product-comparison-grid', ProductComparisonGrid);
}
